// login.js

import {
    getService,
    postService
} from '../api/service.js'
/**
 * name 登录
 * time 2021-09-07
 * param userName String 账号
 * param password String 密码
 * return String token
 * */
// 视频设置列表
export const getVideoConfigListPost = params => {
    return postService('/api/jfy/getVideoConfigList', params)
}
// 视频类型
export const videoTypeListPost = params => {
    return postService('/api/jfy/videoTypeList', params)
}
// 添加视频
export const addVideoPost = params => {
    return postService('/api/jfy/addVideo', params)
}
// 视频删除
export const videoConfigDeletePost = params => {
    return postService('/api/jfy/videoConfigDelete', params)
}
// 视频置顶
export const videoTopPost = params => {
    return postService('/api/jfy/videoTop', params)
}
// 修改视频
export const updateVideo = params => {
    return postService('/api/jfy/updateVideo', params)
}
// 视频详情

export const getVideoInfo = params => {
    return postService('/api/jfy/getVideoInfo', params)
}
// 移动

export const videoMove = params => {
    return postService('/api/jfy/videoMove', params)
}
/**
 * name 登出
 * time 2021-09-07
 * */
export const codeGet = params => {
    return getService('/api/auth/getCaptcha', params)
}